/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestCommerceBillingModel } from './QuestCommerceBillingModel';
import {
    QuestCommerceBillingModelFromJSON,
    QuestCommerceBillingModelFromJSONTyped,
    QuestCommerceBillingModelToJSON,
    QuestCommerceBillingModelToJSONTyped,
} from './QuestCommerceBillingModel';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { BusinessType } from './BusinessType';
import {
    BusinessTypeFromJSON,
    BusinessTypeFromJSONTyped,
    BusinessTypeToJSON,
    BusinessTypeToJSONTyped,
} from './BusinessType';
import type { MerchantType } from './MerchantType';
import {
    MerchantTypeFromJSON,
    MerchantTypeFromJSONTyped,
    MerchantTypeToJSON,
    MerchantTypeToJSONTyped,
} from './MerchantType';
import type { MenuItemSearchEssential } from './MenuItemSearchEssential';
import {
    MenuItemSearchEssentialFromJSON,
    MenuItemSearchEssentialFromJSONTyped,
    MenuItemSearchEssentialToJSON,
    MenuItemSearchEssentialToJSONTyped,
} from './MenuItemSearchEssential';
import type { BusinessLabel } from './BusinessLabel';
import {
    BusinessLabelFromJSON,
    BusinessLabelFromJSONTyped,
    BusinessLabelToJSON,
    BusinessLabelToJSONTyped,
} from './BusinessLabel';
import type { MenuCategorySearchEssential } from './MenuCategorySearchEssential';
import {
    MenuCategorySearchEssentialFromJSON,
    MenuCategorySearchEssentialFromJSONTyped,
    MenuCategorySearchEssentialToJSON,
    MenuCategorySearchEssentialToJSONTyped,
} from './MenuCategorySearchEssential';
import type { OrderDiscountSearchEssential } from './OrderDiscountSearchEssential';
import {
    OrderDiscountSearchEssentialFromJSON,
    OrderDiscountSearchEssentialFromJSONTyped,
    OrderDiscountSearchEssentialToJSON,
    OrderDiscountSearchEssentialToJSONTyped,
} from './OrderDiscountSearchEssential';
import type { Pos } from './Pos';
import {
    PosFromJSON,
    PosFromJSONTyped,
    PosToJSON,
    PosToJSONTyped,
} from './Pos';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { BusinessServiceAvailability } from './BusinessServiceAvailability';
import {
    BusinessServiceAvailabilityFromJSON,
    BusinessServiceAvailabilityFromJSONTyped,
    BusinessServiceAvailabilityToJSON,
    BusinessServiceAvailabilityToJSONTyped,
} from './BusinessServiceAvailability';
import type { MerchantBrandSize } from './MerchantBrandSize';
import {
    MerchantBrandSizeFromJSON,
    MerchantBrandSizeFromJSONTyped,
    MerchantBrandSizeToJSON,
    MerchantBrandSizeToJSONTyped,
} from './MerchantBrandSize';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { BusinessServiceAvailabilityOverride } from './BusinessServiceAvailabilityOverride';
import {
    BusinessServiceAvailabilityOverrideFromJSON,
    BusinessServiceAvailabilityOverrideFromJSONTyped,
    BusinessServiceAvailabilityOverrideToJSON,
    BusinessServiceAvailabilityOverrideToJSONTyped,
} from './BusinessServiceAvailabilityOverride';
import type { HandoffOptions } from './HandoffOptions';
import {
    HandoffOptionsFromJSON,
    HandoffOptionsFromJSONTyped,
    HandoffOptionsToJSON,
    HandoffOptionsToJSONTyped,
} from './HandoffOptions';
import type { Business } from './Business';
import {
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
    BusinessToJSONTyped,
} from './Business';

/**
 * 
 * @export
 * @interface Merchant
 */
export interface Merchant extends Business {
    /**
     * 
     * @type {number}
     * @memberof Merchant
     */
    prepTime?: number;
    /**
     * 
     * @type {number}
     * @memberof Merchant
     */
    distanceDeliveryMax?: number;
    /**
     * Check whether the menu has successfully imported / loaded. Prevent customers from ordering if menu is not ready.
     * @type {boolean}
     * @memberof Merchant
     */
    isMenuActive?: boolean;
    /**
     * Whether or not the merchant only accepts Advance (a.k.a. later) orders. If so, minimum amount of time beforehand that an order can be placed.
     * @type {number}
     * @memberof Merchant
     */
    minScheduledTime?: number;
    /**
     * Whether or not the merchant supports manual fire orders. Manual Fire is an order time mode that allows orders to be fired at a precise desired moment.
     * @type {number}
     * @memberof Merchant
     */
    supportManualFire?: number;
    /**
     * 
     * @type {number}
     * @memberof Merchant
     */
    pickupMinAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof Merchant
     */
    supportGuestOrdering?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Merchant
     */
    supportTip?: boolean;
    /**
     * Always show menu even if the merchant is closed.
     * @type {boolean}
     * @memberof Merchant
     */
    alwaysShowMenu?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    productRecipientNameLabel?: string;
    /**
     * Whether or not the merchant supports basket transfers to another merchant.
     * @type {boolean}
     * @memberof Merchant
     */
    supportBasketTransfer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Merchant
     */
    showCalories?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Merchant
     */
    acceptOrdersUntilClosing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Merchant
     */
    acceptOrdersBeforeOpening?: boolean;
    /**
     * Dynamic boolean check whether the merchant is open.
     * @type {boolean}
     * @memberof Merchant
     */
    isOpen?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Merchant
     */
    specialInstructions?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Merchant
     */
    specialInstructionsMaxLength?: number;
    /**
     * 
     * @type {number}
     * @memberof Merchant
     */
    deliveryCharge?: number;
    /**
     * 
     * @type {number}
     * @memberof Merchant
     */
    menuImportStart?: number;
    /**
     * 
     * @type {number}
     * @memberof Merchant
     */
    menuImportEnd?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Merchant
     */
    isDeliveryAvailable?: boolean;
    /**
     * Boolean to determine if Chowly is enabled.
     * @type {boolean}
     * @memberof Merchant
     */
    isChowly?: boolean;
    /**
     * Boolean to determine if ItsaCheckmate is enabled.
     * @type {boolean}
     * @memberof Merchant
     */
    isItsaCheckmate?: boolean;
    /**
     * 
     * @type {Array<BusinessServiceAvailability>}
     * @memberof Merchant
     */
    serviceAvailabilities?: Array<BusinessServiceAvailability>;
    /**
     * 
     * @type {Array<BusinessServiceAvailabilityOverride>}
     * @memberof Merchant
     */
    serviceAvailabilitiesOverride?: Array<BusinessServiceAvailabilityOverride>;
    /**
     * 
     * @type {Array<HandoffOptions>}
     * @memberof Merchant
     */
    handoffOptions?: Array<HandoffOptions>;
    /**
     * 
     * @type {Array<MenuCategorySearchEssential>}
     * @memberof Merchant
     */
    menus?: Array<MenuCategorySearchEssential>;
    /**
     * 
     * @type {Array<OrderDiscountSearchEssential>}
     * @memberof Merchant
     */
    promos?: Array<OrderDiscountSearchEssential>;
    /**
     * 
     * @type {Array<MenuItemSearchEssential>}
     * @memberof Merchant
     */
    secretMenuItems?: Array<MenuItemSearchEssential>;
    /**
     * 
     * @type {MerchantType}
     * @memberof Merchant
     */
    subtype?: MerchantType;
    /**
     * 
     * @type {MerchantBrandSize}
     * @memberof Merchant
     */
    brandSize?: MerchantBrandSize;
    /**
     * 
     * @type {Pos}
     * @memberof Merchant
     */
    menuSource?: Pos;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    oAuthAccess?: string;
    /**
     * 
     * @type {number}
     * @memberof Merchant
     */
    oloVendorId?: number;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    uberEatsUUID?: string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    uberEatsUrl?: string;
    /**
     * Whether this location was imported directly through DevourIQ, or manually through the admin portal.
     * @type {boolean}
     * @memberof Merchant
     */
    isDevourIQManaged?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Merchant
     */
    isDevourIQ?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Merchant
     */
    isDevourIQMenuFresh?: boolean;
    /**
     * 
     * @type {QuestCommerceBillingModel}
     * @memberof Merchant
     */
    questCommerceBillingModel?: QuestCommerceBillingModel;
    /**
     * Flat fee in cents per redemption (PER_REDEMPTION billing only).
     * @type {number}
     * @memberof Merchant
     */
    questCommercePerRedemptionFee?: number;
    /**
     * Percentage of order subtotal, 0–100 (PERCENTAGE billing only).
     * @type {number}
     * @memberof Merchant
     */
    questCommercePercentageFee?: number;
    /**
     * Flat periodic fee in cents per billing cycle (WEEKLY/MONTHLY billing only).
     * @type {number}
     * @memberof Merchant
     */
    questCommercePeriodFee?: number;
}



/**
 * Check if a given object implements the Merchant interface.
 */
export function instanceOfMerchant(value: object): value is Merchant {
    return true;
}

export function MerchantFromJSON(json: any): Merchant {
    return MerchantFromJSONTyped(json, false);
}

export function MerchantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Merchant {
    if (json == null) {
        return json;
    }
    return {
        ...BusinessFromJSONTyped(json, true),
        'prepTime': json['prepTime'] == null ? undefined : json['prepTime'],
        'distanceDeliveryMax': json['distanceDeliveryMax'] == null ? undefined : json['distanceDeliveryMax'],
        'isMenuActive': json['isMenuActive'] == null ? undefined : json['isMenuActive'],
        'minScheduledTime': json['minScheduledTime'] == null ? undefined : json['minScheduledTime'],
        'supportManualFire': json['supportManualFire'] == null ? undefined : json['supportManualFire'],
        'pickupMinAmount': json['pickupMinAmount'] == null ? undefined : json['pickupMinAmount'],
        'supportGuestOrdering': json['supportGuestOrdering'] == null ? undefined : json['supportGuestOrdering'],
        'supportTip': json['supportTip'] == null ? undefined : json['supportTip'],
        'alwaysShowMenu': json['alwaysShowMenu'] == null ? undefined : json['alwaysShowMenu'],
        'productRecipientNameLabel': json['productRecipientNameLabel'] == null ? undefined : json['productRecipientNameLabel'],
        'supportBasketTransfer': json['supportBasketTransfer'] == null ? undefined : json['supportBasketTransfer'],
        'showCalories': json['showCalories'] == null ? undefined : json['showCalories'],
        'acceptOrdersUntilClosing': json['acceptOrdersUntilClosing'] == null ? undefined : json['acceptOrdersUntilClosing'],
        'acceptOrdersBeforeOpening': json['acceptOrdersBeforeOpening'] == null ? undefined : json['acceptOrdersBeforeOpening'],
        'isOpen': json['isOpen'] == null ? undefined : json['isOpen'],
        'specialInstructions': json['specialInstructions'] == null ? undefined : json['specialInstructions'],
        'specialInstructionsMaxLength': json['specialInstructionsMaxLength'] == null ? undefined : json['specialInstructionsMaxLength'],
        'deliveryCharge': json['deliveryCharge'] == null ? undefined : json['deliveryCharge'],
        'menuImportStart': json['menuImportStart'] == null ? undefined : json['menuImportStart'],
        'menuImportEnd': json['menuImportEnd'] == null ? undefined : json['menuImportEnd'],
        'isDeliveryAvailable': json['isDeliveryAvailable'] == null ? undefined : json['isDeliveryAvailable'],
        'isChowly': json['isChowly'] == null ? undefined : json['isChowly'],
        'isItsaCheckmate': json['isItsaCheckmate'] == null ? undefined : json['isItsaCheckmate'],
        'serviceAvailabilities': json['serviceAvailabilities'] == null ? undefined : ((json['serviceAvailabilities'] as Array<any>).map(BusinessServiceAvailabilityFromJSON)),
        'serviceAvailabilitiesOverride': json['serviceAvailabilitiesOverride'] == null ? undefined : ((json['serviceAvailabilitiesOverride'] as Array<any>).map(BusinessServiceAvailabilityOverrideFromJSON)),
        'handoffOptions': json['handoffOptions'] == null ? undefined : ((json['handoffOptions'] as Array<any>).map(HandoffOptionsFromJSON)),
        'menus': json['menus'] == null ? undefined : ((json['menus'] as Array<any>).map(MenuCategorySearchEssentialFromJSON)),
        'promos': json['promos'] == null ? undefined : ((json['promos'] as Array<any>).map(OrderDiscountSearchEssentialFromJSON)),
        'secretMenuItems': json['secretMenuItems'] == null ? undefined : ((json['secretMenuItems'] as Array<any>).map(MenuItemSearchEssentialFromJSON)),
        'subtype': json['subtype'] == null ? undefined : MerchantTypeFromJSON(json['subtype']),
        'brandSize': json['brandSize'] == null ? undefined : MerchantBrandSizeFromJSON(json['brandSize']),
        'menuSource': json['menuSource'] == null ? undefined : PosFromJSON(json['menuSource']),
        'oAuthAccess': json['oAuthAccess'] == null ? undefined : json['oAuthAccess'],
        'oloVendorId': json['oloVendorId'] == null ? undefined : json['oloVendorId'],
        'uberEatsUUID': json['uberEatsUUID'] == null ? undefined : json['uberEatsUUID'],
        'uberEatsUrl': json['uberEatsUrl'] == null ? undefined : json['uberEatsUrl'],
        'isDevourIQManaged': json['isDevourIQManaged'] == null ? undefined : json['isDevourIQManaged'],
        'isDevourIQ': json['isDevourIQ'] == null ? undefined : json['isDevourIQ'],
        'isDevourIQMenuFresh': json['isDevourIQMenuFresh'] == null ? undefined : json['isDevourIQMenuFresh'],
        'questCommerceBillingModel': json['questCommerceBillingModel'] == null ? undefined : QuestCommerceBillingModelFromJSON(json['questCommerceBillingModel']),
        'questCommercePerRedemptionFee': json['questCommercePerRedemptionFee'] == null ? undefined : json['questCommercePerRedemptionFee'],
        'questCommercePercentageFee': json['questCommercePercentageFee'] == null ? undefined : json['questCommercePercentageFee'],
        'questCommercePeriodFee': json['questCommercePeriodFee'] == null ? undefined : json['questCommercePeriodFee'],
    };
}

export function MerchantToJSON(json: any): Merchant {
    return MerchantToJSONTyped(json, false);
}

export function MerchantToJSONTyped(value?: Merchant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...BusinessToJSONTyped(value, true),
        'prepTime': value['prepTime'],
        'distanceDeliveryMax': value['distanceDeliveryMax'],
        'isMenuActive': value['isMenuActive'],
        'minScheduledTime': value['minScheduledTime'],
        'supportManualFire': value['supportManualFire'],
        'pickupMinAmount': value['pickupMinAmount'],
        'supportGuestOrdering': value['supportGuestOrdering'],
        'supportTip': value['supportTip'],
        'alwaysShowMenu': value['alwaysShowMenu'],
        'productRecipientNameLabel': value['productRecipientNameLabel'],
        'supportBasketTransfer': value['supportBasketTransfer'],
        'showCalories': value['showCalories'],
        'acceptOrdersUntilClosing': value['acceptOrdersUntilClosing'],
        'acceptOrdersBeforeOpening': value['acceptOrdersBeforeOpening'],
        'isOpen': value['isOpen'],
        'specialInstructions': value['specialInstructions'],
        'specialInstructionsMaxLength': value['specialInstructionsMaxLength'],
        'deliveryCharge': value['deliveryCharge'],
        'menuImportStart': value['menuImportStart'],
        'menuImportEnd': value['menuImportEnd'],
        'isDeliveryAvailable': value['isDeliveryAvailable'],
        'isChowly': value['isChowly'],
        'isItsaCheckmate': value['isItsaCheckmate'],
        'serviceAvailabilities': value['serviceAvailabilities'] == null ? undefined : ((value['serviceAvailabilities'] as Array<any>).map(BusinessServiceAvailabilityToJSON)),
        'serviceAvailabilitiesOverride': value['serviceAvailabilitiesOverride'] == null ? undefined : ((value['serviceAvailabilitiesOverride'] as Array<any>).map(BusinessServiceAvailabilityOverrideToJSON)),
        'handoffOptions': value['handoffOptions'] == null ? undefined : ((value['handoffOptions'] as Array<any>).map(HandoffOptionsToJSON)),
        'menus': value['menus'] == null ? undefined : ((value['menus'] as Array<any>).map(MenuCategorySearchEssentialToJSON)),
        'promos': value['promos'] == null ? undefined : ((value['promos'] as Array<any>).map(OrderDiscountSearchEssentialToJSON)),
        'secretMenuItems': value['secretMenuItems'] == null ? undefined : ((value['secretMenuItems'] as Array<any>).map(MenuItemSearchEssentialToJSON)),
        'subtype': MerchantTypeToJSON(value['subtype']),
        'brandSize': MerchantBrandSizeToJSON(value['brandSize']),
        'menuSource': PosToJSON(value['menuSource']),
        'oAuthAccess': value['oAuthAccess'],
        'oloVendorId': value['oloVendorId'],
        'uberEatsUUID': value['uberEatsUUID'],
        'uberEatsUrl': value['uberEatsUrl'],
        'isDevourIQManaged': value['isDevourIQManaged'],
        'isDevourIQ': value['isDevourIQ'],
        'isDevourIQMenuFresh': value['isDevourIQMenuFresh'],
        'questCommerceBillingModel': QuestCommerceBillingModelToJSON(value['questCommerceBillingModel']),
        'questCommercePerRedemptionFee': value['questCommercePerRedemptionFee'],
        'questCommercePercentageFee': value['questCommercePercentageFee'],
        'questCommercePeriodFee': value['questCommercePeriodFee'],
    };
}

